import React from "react";
import { Routes, Route, Navigate, useRoutes } from "react-router-dom";

import LoginPage from "../../pages/Login/LoginPage";
import DashboardPage from "../../pages/Dashboard/DashboardPage";

import DashboardLayout from "../../containers/Dashboard/Dashboard";
import UsersPage from "../../pages/Users/UsersPage";

import ForgotPassword from "../../containers/ForgotPassword/ForgotPassword";
import OtpScreen from "../../containers/OtpScreen/OtpScreen";
import ChangePassword from "../../containers/ChangePassword/ChangePassword";
import ClientList from "../../pages/ClientList/ClientList";
import RevenueSheet from "../../pages/Earnings/RevenueSheet/RevenueSheet";
import Payouts from "../../pages/Earnings/Payouts/Payouts";
import MainProfile from "../../pages/MainPofile/MainProfile";
import SignupPage from "../../pages copy/SignupPage";
import SignUpLayout from "../../SignUpLayout/SignUpLayout";
import MobilePage from "../../pages copy/MobilePage";
import ConfirmOtpPage from "../../pages copy/ConfirmOTPPage";
import YourDetails from "../../pages copy/YourDetailsPage";
import ConfirmEmailOtpPage from "../../pages copy/ConfirmEmailOtp";
import PanVerificationPage from "../../pages copy/PanVerificationPage";
import ContactSupport from "../../pages copy/ContactSupport";
import GeneratePartnerCode from "../../pages copy/GeneratePartnerCode";
import AadhaarKYCPage from "../../pages copy/AadharKYCPage";
import TradingPreference from "../../pages copy/TradingPreference";
import YourProfilePage from "../../pages copy/YourProfilePage";
import LinkUsingIFSC from "../../pages copy/LinkUsingIFSC";
import WebcamDemo from "../../Components copy/CameraModule/WebCamFaceDetection";
import UploadDocumentsPage from "../../pages copy/UploadDocumentsPage";
import NomineesPage from "../../pages copy/NomineePage";
import KraEsignPage from "../../pages copy/kraEsign";
import EsignPage from "../../pages copy/EsignPage";
import TermsandConditionsPage from "../../pages copy/TermsandConditionsPage";
import PageNotFound from "../../pages copy/PageNotFound";
import CongratulationsPage from "../../pages copy/CongratulationsPage";
import CompletedPage from "../../pages copy/CompletedPage";
import SuccessEsignPage from "../../pages copy/SuccessEsignPage";
import SuccessAadhaarPage from "../../pages copy/SuccessAadhaarPage";

// import Register from '../../containers/Register/Register';
// import ForgotPassword from '../../containers/ForgotPassword/ForgotPassword';
// import OtpScreen from '../../containers/OtpScreen/OtpScreen';
// import ChangePassword from '../../containers/ChangePassword/ChangePassword';
// import SuccessModal from '../SuccessModal/SuccessModal';

// import RegisterOtp from '../../containers/Register/RegisterOtp/RegisterOtp';

// const Router = () => {
//   return (
//     <div>
//       <Routes>
//         <Route>
//           {/* <Route path="/register" element={<Register />} />  */}
//           {/* <Route path="" element={<LoginPage/>}/> */}
//           {/* <Route path="/forgotPassword" element={<ForgotPassword/>}/> */}
//           {/* <Route path="/otpScreen" element={<OtpScreen/>}/> */}
//           {/* <Route path="/changePassword" element={<ChangePassword/>}/> */}
//           {/* <Route path="/successModal" element={<SuccessModal/>}/> */}
//           <Route path="/dashboard" element={<Dashboard />} />
//           {/* <Route path="/RegisterOtp" element={<RegisterOtp/>}/> */}
//         </Route>
//       </Routes>
//     </div>
//   );
// };
function Router() {
  const routes = useRoutes([
    {
      path: "",
      element: <SignUpLayout />,
      children: [
        { element: <Navigate to="home" />, index: true },
        {
          path: `home`,
          element: <SignupPage />,
        },
        {
          path: `mobile`,
          element: <MobilePage />,
        },
        {
          path: "confirm_otp",
          element: <ConfirmOtpPage />,
        },
        {
          path: "yourdetails",
          element: <YourDetails />,
        },
        {
          path: "confirmemailotp",
          element: <ConfirmEmailOtpPage />,
        },

        {
          path: "panverification",
          element: <PanVerificationPage />,
        },
        {
          path: "support",
          element: <ContactSupport />,
        },
        {
          path: "generatePartnerCode",
          element: <GeneratePartnerCode />,
        },
        {
          path: "aadhaarkyc",
          element: <AadhaarKYCPage />,
        },
        {
          path: "tradingPreference",
          element: <TradingPreference />,
        },
        {
          path: "yourprofile",
          element: <YourProfilePage />,
        },
        {
          path: "linkusingifsc",
          element: <LinkUsingIFSC />,
        },
        {
          path: "cameramodule",
          element: <WebcamDemo />,
        },

        {
          path: "uploaddocuments",
          element: <UploadDocumentsPage />,
        },
        {
          path: "nomineepage",
          // element: <NewNominee />
          element: <NomineesPage />,
        },
        {
          path: "kraesign",
          element: <KraEsignPage />,
        },
        {
          path: "esign",
          element: <EsignPage />,
        },

        {
          path: "termsandconditions",
          element: <TermsandConditionsPage />,
        },
        {
          path: "/*",
          element: <PageNotFound />,
        },

        {
          path: "congratulations",
          element: <CongratulationsPage />,
        },
        {
          path: "completed",
          element: <CompletedPage />,
        },
        {
          path: "digilocker_aadhaar/*",
          element: <SuccessAadhaarPage />,
        },
        {
          path: "ekyc_esign/*",
          element: <SuccessEsignPage />,
        },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      path: "/forgotPassword",
      element: <ForgotPassword />,
    },
    {
      path: "/otpScreen",
      element: <OtpScreen />,
    },
    {
      path: "/changePassword",
      element: <ChangePassword />,
    },

    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="home" />, index: true },
        {
          path: `home`,
          element: <DashboardPage />,
        },
        {
          path: `clients`,
          element: <ClientList />,
        },

        {
          path: `earnings`,
          // element: <UsersPage />,
          children: [
            {
              element: <Navigate to="/dashboard/earnings/revenue" />,
              index: true,
            },
            {
              path: `revenue`,
              element: <RevenueSheet />,
            },
            {
              path: `payout`,
              element: <Payouts />,
            },
          ],
        },
        {
          path: `profile`,
          element: <MainProfile />,
        },
      ],
    },
    {
      path: "/clients",
      // element: <DashboardLayout />,
    },
  ]);
  return routes;
}

export default Router;
